import React, { useState, useEffect } from 'react';
import { MdOutlineCategory } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { BsBoxSeam } from "react-icons/bs";
import { FaRegCalendarAlt } from "react-icons/fa";
import { BASE_URL, USER_URL } from '../../constant/api';
import axios from 'axios';
import ScaleLoader from 'react-spinners/ScaleLoader';

// Reusable Input Component
const InputField = ({ type, placeholder, icon: Icon, className, ...rest }) => {
    return (
        <div className={`relative ${className}`}>
            {Icon && <Icon className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-400" />}
            <input
                type={type}
                placeholder={placeholder}
                className="p-2 pl-5 border border-gray-300 rounded-md w-full"
                {...rest}
            />
        </div>
    );
};

// Reusable Button Component
const Button = ({ children, className, ...rest }) => {
    return (
        <button
            className={`bg-green-500 text-white p-2 rounded-md hover:bg-green-600 ease-in-out duration-500 ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
};

function SellerSalesView() {
    const [sales, setSales] = useState([]);
    const [filteredSales, setFilteredSales] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [startDate, setStartDate] = useState('');
    const [customer_name, setCustomer_name] = useState('');
    const [area, setArea] = useState('');

    // Simulate fetching data
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await USER_URL.get(`/orders/seller/sales-view/`, {
                    // headers: { 'Authorization': `Token ${token}` },
                });
                setSales(response.data.Data);
                setFilteredSales(response.data.Data); // Initially show all sales
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchProducts();
    }, [token]);

    // Handle Search
    const handleSearch = () => {
        let filteredData = [...sales];

        // Filter by start date if specified
        if (startDate) {
            filteredData = filteredData.filter(product => product.date >= startDate);
        }

        // Filter by items if specified
        if (customer_name) {
            filteredData = filteredData.filter(product => product.customer_name.toLowerCase().includes(customer_name.toLowerCase()));
        }

        // Filter by area if specified
        if (area) {
            filteredData = filteredData.filter(product => product.place.toLowerCase().includes(area.toLowerCase()));
        }

        setFilteredSales(filteredData);
    };

    return (
        <div>
            <div className="max-w-md mt-5">
                <h1 className="text-2xl font-bold mb-4 text-center">Search</h1>
                <div className="grid grid-cols-4 gap-4">
                    {/* Start Date Input */}
                    <InputField
                        type="date"
                        className="col-span-2"
                        placeholder="Start Date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />

                    {/* Items Input */}
                    <InputField
                        type="text"
                        placeholder="Customer Name"
                        icon={MdOutlineCategory}
                        className="col-span-2"
                        value={customer_name}
                        onChange={(e) => setCustomer_name(e.target.value)}
                    />

                    {/* Area Input */}
                    <InputField
                        type="text"
                        placeholder="Area"
                        icon={SlLocationPin}
                        className="col-span-2"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                    />

                    {/* Search Button */}
                    <Button className="col-span-2" onClick={handleSearch}>
                        Search
                    </Button>
                </div>
            </div>

            {/* Table Section */}
            <div className="overflow-x-auto mt-5">
                {isLoading ? (
                    <div className="flex justify-center items-center h-64">
                        <ScaleLoader color="#FFAE00" height={40} />
                    </div>
                ) : filteredSales.length === 0 ? (
                    <div className="text-center mt-10">
                        <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
                        <p className="text-lg text-gray-600">No sales available</p>
                    </div>
                ) : (
                    <>
                        {/* Table Header */}
                        <div className="min-w-[800px] grid grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
                            <div className="text-center">Customer Name</div>
                            <div className="text-center">Invoice No</div>
                            <div className="text-center">Time</div>
                            <div className="text-center">Date</div>
                            <div className="text-center">Place</div>
                            <div className="text-center">Quantity</div>
                            <div className="text-center">Status</div>
                            <div className="text-center">Total amount</div>
                        </div>

                        {/* Table Body */}
                        {filteredSales.map((product, index) => (
                            <div
                                key={product.id}
                                className="grid text-[#2F2E41] min-w-[800px] grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2"
                            >
                                <div className="line-clamp-1 rounded-xl border p-2 text-center">{product.customer_name}</div>
                                <div className="border p-2 rounded-xl text-center line-clamp-1">{product.order_number}</div>
                                <div className="border p-2 rounded-xl text-center">{product.time}</div>
                                <div className="border p-2 rounded-xl text-center">{product.date}</div>
                                <div className="border p-2 rounded-xl text-center">{product.place}</div>
                                <div className="border p-2 rounded-xl text-center">{product.quantity}</div>
                                <div className="border p-2 rounded-xl text-center">{product.status}</div>
                                <div className="border p-2 rounded-xl text-center">{product.total_amount}</div>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
}

export default SellerSalesView;
